import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CustomFieldsIcon, ChevronDownIcon } from '../icons';
import CustomFieldEditor from './CustomFieldEditor';
import './CustomFieldsDropdown.css';

/**
 * CustomFieldsDropdown Component
 * Dropdown for setting custom fields of selected missions
 */
const CustomFieldsDropdown = ({
  isActive,
  onToggle,
  onCustomFieldChange,
  customFields,
  menuStyle,
  buttonRef,
}) => {
  const [editingCustomField, setEditingCustomField] = useState(null);
  const [customFieldInputValue, setCustomFieldInputValue] = useState('');
  const customFieldInputRef = useRef(null);

  // Focus input when editing
  useEffect(() => {
    if (editingCustomField && customFieldInputRef.current) {
      customFieldInputRef.current.focus();
    }
  }, [editingCustomField]);

  const handleFieldSelect = (field) => {
    setEditingCustomField({ fieldId: field.id, fieldType: field.type });
    setCustomFieldInputValue('');
  };

  const handleBackToList = () => {
    setEditingCustomField(null);
    setCustomFieldInputValue('');
  };

  const handleApply = (fieldId, value) => {
    onCustomFieldChange(fieldId, value);
    setEditingCustomField(null);
    setCustomFieldInputValue('');
  };

  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => {
          onToggle('customFields', e.currentTarget);
          setEditingCustomField(null);
          setCustomFieldInputValue('');
        }}
        title="Set custom fields"
      >
        <CustomFieldsIcon />
        <span>Fields</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu bulk-actions-toolbar__menu--custom-fields" style={menuStyle}>
          {editingCustomField ? (
            <CustomFieldEditor
              editingCustomField={editingCustomField}
              customFieldInputValue={customFieldInputValue}
              setCustomFieldInputValue={setCustomFieldInputValue}
              customFieldInputRef={customFieldInputRef}
              customFields={customFields}
              onBack={handleBackToList}
              onApply={handleApply}
            />
          ) : (
            <>
              <div className="bulk-actions-toolbar__custom-fields-header">
                <span className="bulk-actions-toolbar__tags-section-title">Set Custom Field</span>
              </div>
              {customFields.map(field => (
                <button
                  key={field.id}
                  className="bulk-actions-toolbar__menu-item"
                  onClick={() => handleFieldSelect(field)}
                >
                  <span className="bulk-actions-toolbar__custom-field-type-icon">
                    {field.type === 'text' && 'Aa'}
                    {field.type === 'number' && '#'}
                    {field.type === 'checkbox' && '☑'}
                    {field.type === 'select' && '▾'}
                    {field.type === 'date' && '📅'}
                    {field.type === 'url' && '🔗'}
                  </span>
                  <span>{field.name}</span>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginLeft: 'auto', opacity: 0.5 }}>
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ))}
            </>
          )}
        </div>,
        document.body
      )}
    </div>
  );
};

export default CustomFieldsDropdown;
